import {
  INSTORE_TAB_GET_FAILURE, INSTORE_TAB_GET_SUCCESS,
} from '../actions/types';

const initialState = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const records = (state = initialState, action) => {
  switch (action.type) {
    case INSTORE_TAB_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: action.payload,
      };
    }
    case INSTORE_TAB_GET_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: {},
      };
    }
    default: {
      const { options = {} } = action;

      if (options.success === INSTORE_TAB_GET_SUCCESS) {
        return {
          ...state,
          isLoading: true,
          isLoaded: false,
        };
      }
    }
  }

  return state;
};

export default records;
